import React from 'react';
import { TableRow, TableCell, Checkbox, IconButton, Typography, Chip } from '@mui/material';
import { MoreVert as MoreIcon, Star } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

const WarehousesTableRow = ({
    item,
    index = 0,
    isSelected,
    onRowCheckboxClick,
    onMenuOpen,
}) => {
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || 'en').startsWith('ar');

    return (
        <TableRow hover selected={isSelected}>
            <TableCell padding="checkbox">
                <Checkbox checked={isSelected} onClick={(e) => onRowCheckboxClick(e, item.id)} />
            </TableCell>

            <TableCell align="start">{index + 1}</TableCell>

            <TableCell>
                <Typography variant="body2" fontWeight="medium">{item.name || '-'}</Typography>
            </TableCell>

            <TableCell align="center">
                {item.is_default ? (
                    <Chip
                        size="small"
                        icon={<Star sx={{ fontSize: 14 }} />}
                        label={isArabic ? 'افتراضي' : 'Default'}
                        color="primary"
                        variant="tonal"
                        sx={{ fontWeight: 'bold', borderRadius: '6px' }}
                    />
                ) : (
                    <Typography variant="caption" color="text.secondary">—</Typography>
                )}
            </TableCell>

            <TableCell align="center">
                <Typography variant="body2" sx={{ whiteSpace: 'nowrap' }}>
                    {item.created_at ? dayjs(item.created_at).format('YYYY-MM-DD') : '-'}
                </Typography>
            </TableCell>

            <TableCell align="center">
                <IconButton size="small" onClick={(e) => onMenuOpen(e, item)}>
                    <MoreIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default WarehousesTableRow;
